import React, { useState, useEffect } from 'react';


const TypingEffect = () => {
  const strings = ["Branch Banking", "Risk Management", "Remedial & Structured Credits", "Global Operations"];
  const [currentStringIndex, setCurrentStringIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  const typingSpeed = 100;
  const deleteSpeed = 40;
  const isLoop = true;
  const isPlaceholder = true;

  //-------------------------

  

  useEffect(() => {
    const typing = () => {
      if (isPlaceholder) {
        // Handle placeholder typing effect
        // Update your input field's placeholder
        // Example: document.getElementById("yourInputId").placeholder = strings[currentStringIndex].substring(0, currentText.length);
        document.getElementById("auto").placeholder = strings[currentStringIndex].substring(0, currentText.length);
      } else {
        // Handle innerHTML typing effect
        // Update the content of your element
        // Example: document.getElementById("yourElementId").innerHTML = strings[currentStringIndex].substring(0, currentText.length);
        document.getElementById("auto").placeholder = strings[currentStringIndex].substring(0, currentText.length);
      }

      if (currentText.length === strings[currentStringIndex].length) {
        setTimeout(() => {
          setIsTyping(false);
          setCurrentText('');

          if (isLoop || currentStringIndex < strings.length - 1) {
            setTimeout(() => {
              setIsTyping(true);
              setCurrentStringIndex((prevIndex) => (prevIndex + 1) % strings.length);
            }, deleteSpeed);
          }
        }, typingSpeed);
      } else {
        setTimeout(() => {
          setCurrentText((prevText) => strings[currentStringIndex].substring(0, prevText.length + 1));
        }, typingSpeed);
      }
    };

    if (isTyping) {
      typing();
    }
  }, [currentText, currentStringIndex, isLoop, isPlaceholder, isTyping]);

  return (
    <div>
      {/* Your React JSX where you want to display the typing effect */}
      {/* <p>{currentText}</p> */}

      <div class="sform">
        <input type="text" id="auto" placeholder="" class="sfield" />
        <p id="outputcontent">
          <a class="cust-but">Click</a>
        </p>
      </div>
    </div>
  );
};

export default TypingEffect;
